module.exports = __webpack_public_path__ + "static/media/logo.76df2e66.png";